module.exports = __webpack_public_path__ + "img/goldregen-2020-105.19e9941d.jpg";